export default __webpack_public_path__ + "static/media/wrong-answer-126515.c2250901.mp3";